'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var n=({menu:o,useMobileMenu:s,columnTwo:e,className:r})=>jsxRuntime.jsx("nav",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-navbar ${r||""}`),"aria-label":"Toppmeny",children:jsxRuntime.jsxs("div",{className:"content",children:[jsxRuntime.jsx("div",{className:"column-one",children:!s&&jsxRuntime.jsx(jsxRuntime.Fragment,{children:o})}),e&&jsxRuntime.jsx("div",{className:"column-two",children:e&&e}),s&&jsxRuntime.jsx(jsxRuntime.Fragment,{children:o})]})}),m=n;

exports.a = m;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-ASTYLMUP.js.map